import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import RemoteVideo from 'shared/components/VideoConference/RemoteVideo';
import requestsStatuses from 'modules/common/constants/requestsStatuses';
import { startConsultation } from 'modules/conference/actions/startConsultation';
import { isCurrentConversationMCU, isConversationInProgressStatus } from 'modules/appointmentInfo/selectors/currentAppointment';
import { conferenceInProgress, isInWaitingRoom } from 'modules/conference/selectors/consultationInfo';

import {
  getVideoMediaStream,
  toggleAudioMute,
  toggleVideoMute,
  setSoundLevel,
  setPrevSoundLevel,
} from '../../actions/videoConsultation';
import { setSelfAudioStatus } from '../../actions/setSelfAudioStatus';
import { setSelfVideoStatus } from '../../actions/setSelfVideoStatus';
import { stopConsultationWithConfirmation } from '../../actions/stopConsultation';

const mapStateToProps = (state) => {
  const { conference: { consultationInfo, connectionStatus, remoteMedia, consultationLifecycle } } = state;
  const { localMediaPermission } = state.common.browserMediaPermissions;
  const { success, pending } = requestsStatuses;

  return ({
    isCanStartCall: false,
    isMCU: isCurrentConversationMCU(state),
    isSwitched: consultationInfo.switchedLayout,
    isAudioMuted: consultationInfo.selfAudioOff,
    isVideoMuted: consultationInfo.selfVideoOff,
    reconnection: consultationLifecycle.reconnection,
    videoConnected: (connectionStatus.downstream === 4),
    audioDisabled: remoteMedia.audioDisabled,
    videoDisabled: remoteMedia.videoDisabled,
    isCallInProgress: (consultationInfo.startConsultationRequestStatus === success),
    conferenceInProgress: conferenceInProgress(state),
    outputSoundLevel: consultationInfo.outputSoundLevel,
    prevOutputSoundLevel: consultationInfo.prevOutputSoundLevel,
    isConversationInProgressStatus: isConversationInProgressStatus(state),
    isStartCallDisabled: (localMediaPermission !== success || consultationInfo.startConsultationRequestStatus === pending),
    disabledEndButton: consultationInfo.stopConsultationRequestStatus === pending,
    isInWaitingRoom: isInWaitingRoom(state),
  });
};

const mapDispatchToProps = (dispatch) => ({
  getMediaStream: () => dispatch(getVideoMediaStream(false)),
  startCallAction: () => dispatch(startConsultation()),
  setSoundLevel: (value) => dispatch(setSoundLevel(value)),
  setPrevSoundLevel: (value) => dispatch(setPrevSoundLevel(value)),
  endCallAction: () => dispatch(stopConsultationWithConfirmation()),

  muteAudio: () => [
    dispatch(setSelfAudioStatus(true)),
    dispatch(toggleAudioMute(true)),
  ],
  unmuteAudio: () => [
    dispatch(setSelfAudioStatus(false)),
    dispatch(toggleAudioMute(false)),
  ],

  muteVideo: () => [
    dispatch(setSelfVideoStatus(true)),
    dispatch(toggleVideoMute(true)),
  ],
  unmuteVideo: () => [
    dispatch(setSelfVideoStatus(false)),
    dispatch(toggleVideoMute(false)),
  ],
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(RemoteVideo));
